import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import {
  AdditionalOrderColumn,
  CallbackUrlStatus,
  FilterDefinitionType,
  OrderCompletedBy,
  OrderStatus,
  OrdersTab,
} from 'enums';
import { useOrderQueryFilters } from 'hooks';
import { TranslationNamespace } from 'i18n';
import { FilterDefinition, OrderFilters } from 'types';
import { orderUtils } from 'utils';

import { ManageOrdersList } from '../ManageOrderList';

export const AllOrders: React.FC = () => {
  const { t: tFilters } = useTranslation(TranslationNamespace.Common, {
    keyPrefix: 'features.orders.filters',
  });

  useOrderQueryFilters({
    statuses: [OrderStatus.Completed, OrderStatus.Cancelled],
  });

  const additionalFilters: FilterDefinition<OrderFilters>[] = useMemo(
    () => [
      {
        label: tFilters('automation_status'),
        name: 'completedBy',
        type: FilterDefinitionType.Enum,
        enum: OrderCompletedBy,
        getDisplayName: orderUtils.getCompletedByLabel,
      },
      {
        label: tFilters('callback_url_status'),
        name: 'callbackUrlStatus',
        type: FilterDefinitionType.Enum,
        enum: CallbackUrlStatus,
        getDisplayName: orderUtils.getCallbackUrlStatusLabel,
      },
      orderUtils.getStatusFilterDefinition(Object.values(OrderStatus)),
    ],
    [tFilters],
  );

  return (
    <ManageOrdersList
      tab={OrdersTab.All}
      additionalFilters={additionalFilters}
      additionalColumns={[
        AdditionalOrderColumn.StatusActive,
        AdditionalOrderColumn.OrderProcessedBy,
        AdditionalOrderColumn.Validation,
      ]}
    />
  );
};
